/* Sélecteur d'offres : choix de l'offre, une ligne couleur/taille par soutien-gorge, ajout groupé au panier. */
(function () {
  'use strict';

  function init(root) {
    if (root.__boBound) return;
    var dataEl = root.querySelector('script[data-bo-json]');
    var form = document.getElementById(root.getAttribute('data-form-id'));
    if (!dataEl || !form) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.__boBound = true;

    var byKey = {};
    var byId = {};
    var byColor = {};
    data.variants.forEach(function (v) {
      byKey[v.size + '|' + v.color] = v;
      byId[v.id] = v;
      if (!byColor[v.color]) byColor[v.color] = v;
    });

    var items = [].slice.call(root.querySelectorAll('.bo__item'));
    var errorEl = root.querySelector('.bo__error');
    var busy = false;

    function announce() {
      var it = selectedItem();
      document.dispatchEvent(new CustomEvent('bo:change', { detail: {
        tier: Number(it.getAttribute('data-tier')),
        units: Number(it.getAttribute('data-pay')) + Number(it.getAttribute('data-free')),
        total: Number(it.getAttribute('data-total')),
        compare: Number(it.getAttribute('data-compare')),
        gifts: it.querySelectorAll('.bo__gifts-detail .bo__gift').length
      } }));
    }

    function selectedItem() {
      for (var i = 0; i < items.length; i++) if (items[i].classList.contains('is-selected')) return items[i];
      return items[0];
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function hideError() { if (errorEl) errorEl.hidden = true; }

    function updateThumb(row) {
      var c = row.querySelector('[data-role="color"]').value;
      var z = row.querySelector('[data-role="size"]').value;
      var v = byKey[z + '|' + c] || byColor[c];
      var img = row.querySelector('.bo__thumb');
      if (v && v.img && img && img.getAttribute('src') !== v.img) img.setAttribute('src', v.img);
    }

    function setRow(row, v) {
      var cs = row.querySelector('[data-role="color"]');
      var zs = row.querySelector('[data-role="size"]');
      if (cs.value !== v.color) cs.value = v.color;
      if (zs.value !== v.size) zs.value = v.size;
      updateThumb(row);
    }

    /* Les lignes que le client n'a pas modifiées suivent le choix des sélecteurs du thème (couleur, calculateur de taille). */
    function applyThemeVariant(v) {
      if (!v) return;
      [].forEach.call(root.querySelectorAll('.bo__row'), function (row) {
        if (!row.getAttribute('data-touched')) setRow(row, v);
      });
    }

    function themeVariant() {
      var input = form.querySelector('input[name="id"]');
      return input ? byId[Number(input.value)] : null;
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.bo__card');
      if (!card || e.target.closest('select, label, input, option')) return;
      var input = card.querySelector('.bo__input');
      if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.classList.contains('bo__input')) {
        items.forEach(function (it) { it.classList.toggle('is-selected', it.getAttribute('data-tier') === t.value); });
        hideError();
        announce();
      } else if (t.classList.contains('bo__select')) {
        var row = t.closest('.bo__row');
        row.setAttribute('data-touched', '1');
        updateThumb(row);
        hideError();
      }
    });

    function onVariantChange(e) {
      var v = e && e.detail && e.detail.variant;
      if (v && byId[v.id]) applyThemeVariant(byId[v.id]);
    }
    form.addEventListener('variant:change', onVariantChange);
    document.addEventListener('variant:change', onVariantChange);
    applyThemeVariant(themeVariant());
    announce();

    function setBusy(on) {
      busy = on;
      var buttons = [].slice.call(document.querySelectorAll('[type="submit"][form="' + form.getAttribute('id') + '"]'));
      var own = form.querySelector('[type="submit"]');
      if (own && buttons.indexOf(own) === -1) buttons.push(own);
      buttons.forEach(function (b) {
        if (on) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-busy', 'true'); }
        else { b.removeAttribute('aria-disabled'); b.removeAttribute('aria-busy'); }
      });
    }

    function buildPayload() {
      var item = selectedItem();
      var tag = 'offre-' + item.getAttribute('data-tier');
      var order = [];
      var qty = {};
      var rows = item.querySelectorAll('.bo__row');
      for (var i = 0; i < rows.length; i++) {
        var c = rows[i].querySelector('[data-role="color"]').value;
        var z = rows[i].querySelector('[data-role="size"]').value;
        var v = byKey[z + '|' + c];
        if (!v || !v.available) {
          return { error: (root.getAttribute('data-error-unavailable') || 'Indisponible : {color} / {size}').replace('{color}', c).replace('{size}', z) };
        }
        if (!qty[v.id]) { qty[v.id] = 0; order.push(v.id); }
        qty[v.id] += 1;
      }
      var lines = order.map(function (id) { return { id: id, quantity: qty[id], properties: { _bundle: tag } }; });
      [].forEach.call(item.querySelectorAll('.bo__gifts-detail .bo__gift[data-variant-id]'), function (g) {
        lines.push({ id: Number(g.getAttribute('data-variant-id')), quantity: 1, properties: { _bundle: tag + '-cadeau' } });
      });
      return { items: lines };
    }

    function addToCart(submitter) {
      if (busy) return;
      hideError();
      var payload = buildPayload();
      if (payload.error) { showError(payload.error); return; }

      var sections = [];
      try {
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
      } catch (err) { /* sans conséquence */ }
      var body = { items: payload.items };
      if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            showError(res.json.description || res.json.message || 'Impossible d\'ajouter cette offre au panier.');
            return null;
          }
          if (window.theme && theme.settings && theme.settings.cartType === 'page') { window.location.href = '/cart'; return null; }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cart.sections = res.json.sections;
              if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: payload.items[0].id,
                  cart: cart
                });
              }
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.json } }));
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.show === 'function') drawer.show(submitter || form.querySelector('[type="submit"]'));
            });
        })
        .catch(function () { showError('Une erreur est survenue. Réessaie dans un instant.'); })
        .then(function () { setBusy(false); });
    }

    document.addEventListener('submit', function (e) {
      if (e.target !== form || !root.isConnected) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(e.submitter);
    }, true);
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-bundle-offer]'), init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
